// extracted by mini-css-extract-plugin
module.exports = {"appErrorComponent":"appErrorComponent__3xEMe","message":"message__2KFfW","title":"title__3XzgR","body":"body__3T3Lw","btn":"btn__gSqZV btn__2xACm"};